module.exports = __webpack_public_path__ + "1f2c32457c5ad5e9d7e9d2289d49df6b.svg";